import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {

  const [activeDropdown, setActiveDropdown] = useState(null);
  

  const handleMouseEnter = (menu) => {
    setActiveDropdown(menu);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const serviceItems = [
    { name: 'Hardware Installation', path: '/services/hardware-installation' },
    { name: 'System Maintenance', path: '/services/system-maintenance' },
    { name: 'Technical Support', path: '/services/technical-support' },
    { name: 'Server Management', path: '/services/server-management' },
    { name: 'Security Solutions', path: '/services/security-solutions' },
  ];

  const ourStoryItems = [
    { name: 'About Us', path: '/about' },
    { name: 'Certificates', path: '/certificates' },
    //{ name: 'Careers', path: '/careers' }
  ];

  const downloadItems = [
    { name: 'AnyDesk', href: 'https://www.sysmaco.in/download/AA_v3.5.zip' },
    { name: 'Team Viewer', href: 'https://www.sysmaco.in/download/TeamViewerQS_x64.zip' },
    { name: 'Ammyy', href: 'https://www.sysmaco.in/download/AA_v3.5.zip' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src="/images/sysmaco-symbol.png"
                alt="Sysmaco Logo"
                className="footer-logo-image"
              />
            </div>
            <p className="footer-description">
              Your trusted partner in IT Hardware, Network Maintenance, and Sales.
              Providing reliable technology solutions since day one.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Services</h3>
            <ul className="footer-links">
              {serviceItems.map((item) => (
                <li key={item.path}><a href={item.path}>{item.name}</a></li>
              ))}
              <li>
                {/* Download Button with Dropdown - Desktop */}
                <div
                  className="download-dropdown"
                  onMouseEnter={() => handleMouseEnter('download')}
                  onMouseLeave={handleMouseLeave}
                >
                  <button className="btn btn-primary download-btn" aria-haspopup="true" aria-expanded={activeDropdown === 'download'}>
                    Download <span className="dropdown-arrow">▶</span>
                  </button>
                  {activeDropdown === 'download' && (
                    <div className="download-dropdown-menu">
                      {downloadItems.map((item, index) => (
                        <a
                          key={index}
                          className="download-dropdown-item"
                          href={item.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              {ourStoryItems.map((item) => (
                <li key={item.path}><a href={item.path}>{item.name}</a></li>
              ))}

            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact Info</h3>
            <div className="contact-info">
              <p>📧 <a href="mailto:info@sysmaco.in">info@sysmaco.in</a></p>
              <p>📞 <a href='tel:+91 (33) 35531279' >+91 (33) 35531279</a></p>
              <p>
                <span className="whatsapp-icon" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false">
                    <path fill="#25D366" d="M12 2c5.5 0 10 4.5 10 10 0 5.52-4.48 10-10 10-1.76 0-3.41-.46-4.84-1.28L4 22l1.33-3.09C4.48 17.41 4 15.76 4 14 4 6.5 6.5 2 12 2z" />
                    <path fill="#fff" d="M16.54 13.37c-.23-.12-1.35-.67-1.56-.74-.21-.08-.36-.12-.51.12-.15.23-.59.74-.72.9-.13.15-.27.17-.5.06-.23-.12-.98-.36-1.87-1.14-.69-.61-1.14-1.36-1.27-1.59-.13-.23-.01-.36.1-.48.1-.1.23-.27.35-.4.12-.13.15-.23.23-.38.08-.15.04-.28-.02-.4-.06-.12-.51-1.23-.7-1.69-.18-.44-.37-.38-.51-.39-.13-.01-.28-.01-.43-.01-.15 0-.4.06-.61.28-.21.23-.8.78-.8 1.9 0 1.12.82 2.2.93 2.35.12.15 1.62 2.48 3.93 3.48.55.24.98.38 1.31.49.55.18 1.05.15 1.45.09.44-.07 1.35-.55 1.54-1.08.19-.53.19-.98.13-1.08-.06-.1-.21-.16-.44-.28z" />
                  </svg>
                </span>
                <a className="whatsapp-link" href="https://wa.me/919831024375" target="_blank" rel="noopener noreferrer">Chat with us</a>
              </p>
              <p>📍 <a href="https://www.google.com/maps/search/?api=1&query=Sysmaco+32A+Mahanirban+Road+Kolkata+700029">32A, Mahanirban Road, Kolkata-700029</a></p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Sysmaco. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
